import {
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { ProjectSortOrder } from "./projectSortOrder";


export namespace GetAllActiveProjectsSortOrderEnums {
  /* eslint-disable @typescript-eslint/no-shadow */
  export namespace ColumnName {
    export enum ColumnName {
      PROJECT_NAME = "PROJECT_NAME",
      CREATED_ON = "CREATED_ON",
      LAST_MODIFIED = "LAST_MODIFIED",
    }
  
    export interface ColumnNameDTO {
      case: string;
    }
  
    export const fromDTO = (dto: ColumnNameDTO): ColumnName => {
      if (dto === undefined || dto === null) {
        throw new InvalidGetAllActiveProjectsSortOrderColumnNameError(
          `Invalid DTO ${dto} provided for ColumnName.ColumnName`
        );
      }
      switch (dto.case) {
        case "PROJECT_NAME":
          return ColumnName.PROJECT_NAME;
        case "CREATED_ON":
          return ColumnName.CREATED_ON;
        case "LAST_MODIFIED":
          return ColumnName.LAST_MODIFIED;
        default:
          throw new InvalidGetAllActiveProjectsSortOrderColumnNameError(
            `Case ${dto.case} is not valid case of ColumnName.ColumnName`
          );
      }
    };
  
    export const toDTO = (columnName: ColumnName): ColumnNameDTO => {
      const enumDTO = {
        case: ColumnName[columnName],
      };
      return enumDTO;
    };
  }
  
}
export interface GetAllActiveProjectsSortOrderDTO {
  sortIndex: number;
  columnName: GetAllActiveProjectsSortOrderEnums.ColumnName.ColumnNameDTO;
  order: ProjectSortOrder.ProjectSortOrderDTO;
}

export class GetAllActiveProjectsSortOrder {
  readonly isGetAllActiveProjectsSortOrderGetAllActiveProjectsSortOrder: boolean = true;

  readonly sortIndex: number;
  readonly columnName: GetAllActiveProjectsSortOrderEnums.ColumnName.ColumnName;
  readonly order: ProjectSortOrder.ProjectSortOrder;


  constructor(
  sortIndex: number, 
  columnName: GetAllActiveProjectsSortOrderEnums.ColumnName.ColumnName, 
  order: ProjectSortOrder.ProjectSortOrder
  ) {
    this.sortIndex = sortIndex;
    this.columnName = columnName;
    this.order = order;
  }

  static fromDTO(dto: GetAllActiveProjectsSortOrderDTO): GetAllActiveProjectsSortOrder {
    const sortIndex = getInt32(dto, "sortIndex", InvalidGetAllActiveProjectsSortOrderSortIndexError);
    const columnName = GetAllActiveProjectsSortOrderEnums.ColumnName.fromDTO(getObject(dto, "columnName", InvalidGetAllActiveProjectsSortOrderColumnNameError));
    const order = ProjectSortOrder.fromDTO(getObject(dto, "order", InvalidGetAllActiveProjectsSortOrderOrderError));
    return new GetAllActiveProjectsSortOrder(
      sortIndex,
      columnName,
      order
    );
  }

  toDTO(): GetAllActiveProjectsSortOrderDTO {
    const dto: GetAllActiveProjectsSortOrderDTO = {
        sortIndex: this.sortIndex,
        columnName: GetAllActiveProjectsSortOrderEnums.ColumnName.toDTO(this.columnName),
        order: ProjectSortOrder.toDTO(this.order)
    };
    return dto;
  }
  }

GetAllActiveProjectsSortOrder.prototype.toString = function toString(): string {
  return `GetAllActiveProjectsSortOrder(sortIndex='${this.sortIndex}',columnName='${this.columnName}',order='${this.order}')`;
};

export class InvalidGetAllActiveProjectsSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsSortOrderError";
  }
}
export class InvalidGetAllActiveProjectsSortOrderSortIndexError extends InvalidGetAllActiveProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsSortOrderSortIndexError";
  }
}

export class InvalidGetAllActiveProjectsSortOrderColumnNameError extends InvalidGetAllActiveProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsSortOrderColumnNameError";
  }
}

export class InvalidGetAllActiveProjectsSortOrderColumnNameProjectNameError extends InvalidGetAllActiveProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsSortOrderColumnNameProjectNameError";
  }
}

export class InvalidGetAllActiveProjectsSortOrderColumnNameCreatedOnError extends InvalidGetAllActiveProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsSortOrderColumnNameCreatedOnError";
  }
}

export class InvalidGetAllActiveProjectsSortOrderColumnNameLastModifiedError extends InvalidGetAllActiveProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsSortOrderColumnNameLastModifiedError";
  }
}

export class InvalidGetAllActiveProjectsSortOrderOrderError extends InvalidGetAllActiveProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetAllActiveProjectsSortOrderOrderError";
  }
}
